export default __webpack_public_path__ + "static/media/karakorum.5cafed09.jpg";